import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import { Shadow, Units, Colors } from 'Css';
import Portal from './Portal';

const css = oxygenCss({
  bubble: {
    zIndex: 1000,
    position: 'absolute',
    // boxShadow: Shadow[1],
    backgroundColor: Colors.theme.Light.card,
    color: Colors.text.Dark.secondary,
    // fontSize: 12,
    borderRadius: Units.base / 2,
    display: 'inline-block',
    boxSizing: 'border-box',
    border: `rgba(200, 200, 200, 0.09) solid 1px`,
    fontSize: 14,
    opacity: 0,
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.09)',
    '&padded': {
      padding: Units.base / 2
    },
    '&active': {
      transition: 'opacity 0.25s ease',
      opacity: 1
    },
    '&arrowTop': {
      ':after': {
        bottom: '100%',
        left: '50%',
        border: 'solid transparent',
        content: ' ',
        height: 0,
        width: 0,
        position: 'absolute',
        pointerEvents: 'none',

        borderColor: 'transparent',
        borderBottomColor: Colors.theme.Light.card,
        borderWidth: Units.base,
        marginLeft: `${-Units.base}px`
      },
      ':before': {
        bottom: '100%',
        left: '50%',
        border: 'solid transparent',
        content: ' ',
        height: 0,
        width: 0,
        position: 'absolute',
        pointerEvents: 'none',

        borderColor: 'transparent',
        borderBottomColor: `rgba(200, 200, 200, 0.09)`,
        borderWidth: `${Units.base + 2}px`,
        marginLeft: `${-Units.base - 2}px`
      }
    },
    '&arrowBottom': {
      ':after': {
        top: '100%',
        left: '50%',
        border: 'solid transparent',
        content: ' ',
        height: 0,
        width: 0,
        position: 'absolute',
        pointerEvents: 'none',
        borderColor: 'transparent',
        borderTopColor: Colors.theme.Light.card,
        borderWidth: Units.base,
        marginLeft: `${-Units.base}px`
      },
      ':before': {
        top: '100%',
        left: '50%',
        border: 'solid transparent',
        content: ' ',
        height: 0,
        width: 0,
        position: 'absolute',
        pointerEvents: 'none',
        borderColor: 'transparent',
        borderTopColor: `rgba(200, 200, 200, 0.09)`,
        borderWidth: `${Units.base + 2}px`,
        marginLeft: `${-Units.base - 2}px`
      }
    }
  }
});

function getClientSize() {
  const w = window;
  const d = document;
  const e = d.documentElement;
  const g = d.getElementsByTagName('body')[0];
  const width = w.innerWidth || e.clientWidth || g.clientWidth;
  const height = w.innerHeight || e.clientHeight || g.clientHeight;
  return { width, height };
}

function elementWilFit(el, elHeight) {
  const { height: screenHeight } = getClientSize();
  let top = el.offsetTop;
  const height = el.offsetHeight;

  while (el.offsetParent) {
    el = el.offsetParent;
    top += el.offsetTop;
  }
  return (
    top >= window.pageYOffset &&
    top + height + elHeight <= window.pageYOffset + screenHeight
  );
}

class Tooltip extends Component {
  static propTypes = {
    children: PropTypes.node,
    style: PropTypes.object,
    anchorTo: PropTypes.func,
    padded: PropTypes.bool,
    getPosition: PropTypes.func,
    hasArrow: PropTypes.bool
  };

  static defaultProps = {
    padded: true,
    hasArrow: true,
    width: 256
  };

  state = {
    top: null,
    left: null,
    arrowPosition: 'Top'
  };

  componentDidUpdate() {
    this.position();
  }

  getTooltipStyle() {
    const { top, left } = this.state;
    const { width } = this.props;
    return {
      width,
      transform: `translate3d( ${left || 0}px, ${top || 0}px, 0px)`
    };
  }

  getPosition() {
    const { getPosition } = this.props;
    const rect = this._anchor.getBoundingClientRect();
    const ownRect = this._portal.getBoundingClientRect();
    if (getPosition) {
      return getPosition(rect, ownRect);
    }
    return this.defaultPosition(rect, ownRect);
  }

  defaultPosition(rect, ownRect) {
    const { width, height } = getClientSize();
    if (elementWilFit(this._anchor, ownRect.height)) {
      return {
        arrowPosition: 'Top',
        left: rect.left - ownRect.width / 2 + rect.width / 2,
        top: rect.top + rect.height + Units.base * 2
      };
    } else {
      return {
        arrowPosition: 'Bottom',
        left: rect.left - ownRect.width / 2 + rect.width / 2,
        top: rect.top - rect.height - Units.base * 2 - ownRect.height
      };
    }
  }

  handleMount = portal => {
    const { anchorTo } = this.props;
    this._anchor = anchorTo();
    this._portal = portal;
    this.position();
  };

  position() {
    const { left, top, arrowPosition } = this.getPosition();
    if (
      this.state.left !== left ||
      this.state.top !== top ||
      this.state.arrowPosition !== arrowPosition
    ) {
      this.setState({
        arrowPosition,
        left,
        top
      });
    }
  }

  render() {
    const { children, style, padded, hasArrow, ...other } = this.props;
    const { top, arrowPosition } = this.state;
    return (
      <Portal
        onMount={this.handleMount}
        className={classNames(css.bubble, {
          [css['arrow' + arrowPosition]]: hasArrow,
          [css.padded]: padded,
          [css.active]: top !== null
        })}
        style={this.getTooltipStyle()}
        {...other}
      >
        {children}
      </Portal>
    );
  }
}

export default Tooltip;



// WEBPACK FOOTER //
// ./src/js/Cio/Tooltip.js